<template>
  <!-- Authors Table Card -->
  <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 10 }">
    <template #title>
      <a-row type="flex" align="middle">
        <a-col :span="24" :md="12">
          <h5 class="font-semibold m-0">Achievement Data</h5>
        </a-col>
        <a-col :span="24" :md="12" style="display: flex; align-items: center; justify-content: flex-end">
        </a-col>
      </a-row>
      <a-row type="flex" align="middle" style="margin-top: 20px">
        <a-col :span="10">

          <a-input-search style="margin-left: 0px" placeholder="input search text" enter-button
            v-model="formSearchAchievement.searchText" @search="onSearchAchiev" />

        </a-col>
        <a-col :span="14" align="right">
          <a-button type="primary" class="mr-5" @click="onShowModal('importAchievement')">
            <a-icon type="file-excel" theme="outlined" />Import </a-button>
          <a-button type="primary" :disabled="loadBtnExport" class="mr-5 bg-success" @click="onShowModal('exportAchievementData')">
            <a-icon v-if="!loadBtnExport" type="file-excel" theme="outlined" /><a-spin v-else />
            Export
          </a-button>
        </a-col>
      </a-row>

      <div class="mt-20 mb-5" style="background: #ececec; padding: 10px">
        <a-card class="ant-card-filter" style="box-shadow: none">
          <a-row>
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Member status :</p>
              <!-- <a-radio-group v-model="formSearchAchievement.member">
                <a-radio-button value="member">Member</a-radio-button>
                <a-radio-button value="non-member">Non-Member</a-radio-button>
              </a-radio-group> -->
              <a-button-group>
                <a-button :type="formSearchAchievement.member === 'member' ? 'primary' : 'default'"
                  @click="handleMemberStatusChange('member')">
                  Member
                </a-button>
                <a-button :type="formSearchAchievement.member === 'non-member' ? 'primary' : 'default'"
                  @click="handleMemberStatusChange('non-member')">
                  Non-Member
                </a-button>
              </a-button-group>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Graduation Year :</p>
              <a-select show-search placeholder="Start" style="width: 40%" option-filter-prop="children"
                v-model="formSearchAchievement.yearStart">
                <a-select-option v-for="(item, index) in optionYear" :key="index" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
              -
              <a-select show-search placeholder="End" style="width: 40%" option-filter-prop="children"
                v-model="formSearchAchievement.yearEnd">
                <a-select-option v-for="(item, index) in optionYear" :key="index" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>
          <a-row class="mt-10">
            <!-- <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Nationality :</p>
              <a-select
                show-search
                placeholder="select..."
                style="width: 80%"
                option-filter-prop="children"
                v-model="formSearchAchievement.nationnality"
              >
                <a-select-option
                  v-for="(item, index) in optionNationality"
                  :key="index"
                  :value="item.value"
                >
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-col> -->
            <!-- <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Program :</p>
              <a-select
                show-search
                placeholder="select..."
                style="width: 80%"
                option-filter-prop="children"
                v-model="formSearchAchievement.program"
              >
                <a-select-option
                  v-for="(item, index) in optionProgram"
                  :key="index"
                  :value="item.value"
                >
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-col> -->
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Major :</p>
              <a-select show-search placeholder="select..." style="width: 80%" option-filter-prop="children"
                v-model="formSearchAchievement.major">
                <a-select-option v-for="(item, index) in optionMajor" :key="index" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Type of Awards :</p>
              <a-select show-search placeholder="select..." style="width: 80%" option-filter-prop="children"
                v-model="formSearchAchievement.typeAwards">
                <a-select-option v-for="(item, index) in [
                  'National',
                  'International',
                  'Organizational',
                ]" :key="index" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Fiscal Year :</p>
              <a-select show-search placeholder="Start" style="width: 40%" option-filter-prop="children"
                v-model="formSearchAchievement.fisicalStart">
                <a-select-option v-for="(item, index) in optionYear" :key="index" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
              -
              <a-select show-search placeholder="End" style="width: 40%" option-filter-prop="children"
                v-model="formSearchAchievement.fisicalEnd">
                <a-select-option v-for="(item, index) in optionYear" :key="index" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>
          <!-- <a-row style="margin-top: 20px">
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Fiscal Year :</p>
              <a-select
                show-search
                placeholder="Start"
                style="width: 80%"
                option-filter-prop="children"
                v-model="formSearchAchievement.fisicalStart"
              >
                <a-select-option
                  v-for="(item, index) in optionYear"
                  :key="index"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
              -
              <a-select
                show-search
                placeholder="End"
                style="width: 80%"
                option-filter-prop="children"
                v-model="formSearchAchievement.fisicalEnd"
              >
                <a-select-option
                  v-for="(item, index) in optionYear"
                  :key="index"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row> -->
          <a-row class="mt-20">
            <a-col style="text-align: center">
              <a-button class="mr-5" type="primary" @click="onSearchAchiev">
                <a-icon type="search" theme="outlined" /> Search Data
              </a-button>
              <a-popconfirm placement="top" ok-text="Yes" cancel-text="No" @confirm="onclearFilter">
                <template slot="title">
                  <p>Are you sure to Clear a Filter ?</p>
                </template>
                <a-button type="danger"> Clear Filter </a-button>
              </a-popconfirm>
            </a-col>
          </a-row>
        </a-card>
      </div>
    </template>
    <a-row class="mt-10 mb-10">
      <a-col :span="12" style="text-align: left">
          <a-tag color="blue">
            <p class="text-center mt-5 mb-0 font-bold">
              Total
              <span class="text-danger"> {{ countObjData }}</span>
              record
            </p>
          </a-tag>
        </a-col>
        <a-col :span="12" style="text-align: right">        <a-pagination :current="currentPage" :total="countObjData" @change="onChangePage" :defaultPageSize="perPage" />
      </a-col>
    </a-row>
    <a-table :columns="columns" :data-source="data" :pagination="false" :loading="loading" size="small" bordered
      :scroll="{ x: 1500 }">
      <template slot="created_at" slot-scope="text, record">
        <p class="mt-0 mb-0">
          {{ moment(record.created_at).format("DD / MMMM / YYYY") }}
        </p>
      </template>
      <template slot="grad_year" slot-scope="text, record">
        <p class="mt-0 mb-0">
          {{ record.alumni_profile_detail.graduate_year }}
        </p>
      </template>
      <template slot="academic_title" slot-scope="text, record">
        <div v-if="Object.keys(record.alumni_profile_detail).length !== 0">
          <div v-if="record.alumni_profile_detail.name_detail.length != 0">
            <span v-if="
              record.alumni_profile_detail.name_detail[record.alumni_profile_detail.name_detail.length - 1].academic_title !==
              null
            ">
              {{
                `${checkBlank(
                  record.alumni_profile_detail.name_detail[record.alumni_profile_detail.name_detail.length - 1]
                    .academic_title_detail.name_eng
                )}`
              }}
            </span>
          </div>
        </div>
      </template>
      <template slot="alumni_title" slot-scope="text, record">
        <div v-if="Object.keys(record.alumni_profile_detail).length !== 0">
          <div v-if="record.alumni_profile_detail.name_detail.length != 0">
            <span v-if="
              record.alumni_profile_detail.name_detail[record.alumni_profile_detail.name_detail.length - 1].title_name !== null
            ">
              {{
                `${checkBlank(
                  record.alumni_profile_detail.name_detail[record.alumni_profile_detail.name_detail.length - 1].title_name_detail
                    .name_eng
                )}`
              }}
            </span>
          </div>
        </div>
      </template>
      <template slot="alumni_name" slot-scope="text, record">
        <div v-if="Object.keys(record.alumni_profile_detail).length !== 0">
          <div v-if="record.alumni_profile_detail.name_detail.length != 0">
            {{
              `${checkBlank(
                record.alumni_profile_detail.name_detail[0].eng_first_name
              )} ${checkBlank(
                record.alumni_profile_detail.name_detail[0].eng_middle_name
              )} ${checkBlank(
                record.alumni_profile_detail.name_detail[0].eng_last_name
              )}`
            }}
          </div>
        </div>
      </template>
    </a-table>
    <a-row class="mt-10 mb-10">
      <a-col style="text-align: right">
        <a-pagination :current="currentPage" :total="countObjData" @change="onChangePage" :defaultPageSize="perPage" />
      </a-col>
    </a-row>

    <component :is="currentModalComponent" :viewModal="isShowModal" :onShowModal="onShowModal"
      :onCloseModal="onCloseModal" :lengthDataTable="countObjData"  :dataFilter="formSearchAchievement"></component>

  </a-card>
  <!-- / Authors Table Card -->
</template>

<script>
import importAchievement from "./modal/AchievementImport.vue";
import exportAchievementData from "./modal/ExportAchievementData.vue";

const formSearchAchievement = {
  searchText: "",
  member: "",
  yearStart: "",
  yearEnd: "",
  nationnality: "",
  program: "",
  major: "",
  typeAwards: "",
  fisicalStart: "",
  fisicalEnd: "",
};
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    currentPage: {
      type: Number,
      default: () => 0,
    },
    countObjData: {
      type: Number,
      default: () => 0,
    },
    perPage: {
      type: Number,
      default: () => 0,
    },
    // option search
    optionNationality: {
      type: Array,
      default: () => [],
    },
    optionProgram: {
      type: Array,
      default: () => [],
    },
    optionMajor: {
      type: Array,
      default: () => [],
    },
    optionYear: {
      type: Array,
      default: () => [],
    },
    loadBtnExport: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    checkBlank(val) {
      return !["", null, "null"].includes(val) ? val : "";
    },
    onChangePicker(date, dateString) {
      //console.log(date, dateString);
    },
    onChangePage(current) {
      this.currentPage = current;
      this.offset = parseInt(current - 1) * parseInt(this.perPage);
      this.$emit("changepage", {
        currentPage: this.currentPage,
        offset: this.offset,
      });
    },
    onclearFilter() {
      this.formSearchAchievement = JSON.parse(JSON.stringify(formSearchAchievement))//Object.assign({}, formSearchAchievement);
      this.$emit("search", {
        dataQuery: {},
      });
    },
    onSearchAchiev() {
      this.$emit("search", {
        dataQuery: this.formSearchAchievement,
      });
    },
    handleMemberStatusChange(value) {
      this.formSearchAchievement.member = this.formSearchAchievement.member === value ? '' : value;
    },
    onShowModal(modal) {
      this.isShowModal = true;
      this.currentModalComponent = modal
    },
    onCloseModal() {
      this.onSearchAchiev();
      this.isShowModal = false;
    },
  },
  data() {
    return {
      isShowModal: false,
      currentModalComponent: 'importAchievement',
      formSearchAchievement: JSON.parse(JSON.stringify(formSearchAchievement))//formSearchAchievement//Object.assign({}, formSearchAchievement),
    };
  },
  watch: {},
  components: {
    importAchievement,
    exportAchievementData
  },
};
</script>

<style>
/* #ant-filter .layout-dashboard .ant-card {
    border-radius: 1px;
    box-shadow: 0px 20px 27px rgb(0 0 0 / 1%);
} */
.lable-title {
  margin-top: 5px;
  margin-bottom: 5px;
}

.ant-card-head-title span {
  margin-left: 0px;
}

.ant-card-filter {
  border: none;
}
</style>